import * as React from "react";
import * as api from "../../api/apiFunctions";
import Channel from "../Channel/Channel";
import ChannelPackage from "../ChannelPackage/ChannelPackage";
import Loader from "../Loader/Loader";
import "./App.css";
import {IChannelPackage} from "../../api/apiFunctions";
import {Util} from "../../util";

interface IAppState {
    fixed?: api.IChannelItem[];
    optional?: api.IChannelItem[];
    channelPacks?: api.IChannelPackage[];
    channelType?: ChannelType;
    status: string;
    countryCode: string;
}

enum ChannelType {
    Fixed = "faste",
    Optional = "valgfrie",
    ChannelPacks = "kanalpakker"
}

enum AppStatus {
    Loading = "loading",
    Success = "success",
    Error = "error"
}

class App extends React.Component<{parameter: string}, IAppState> {
    constructor(props: {parameter:string}) {
        super(props);

        this.state = {
            status: AppStatus.Loading,
            countryCode: window.location.hostname.match(/\.dk$/) !== null ? "dk" : "no"
        };
    }

    public setFixedChannels(channels: api.IChannel[]) {
        const fixedChannels = channels.find(tvChannel => tvChannel.name === "Faste kanaler");
        this.setState({
            channelType: ChannelType.Fixed,
            fixed: fixedChannels ? fixedChannels.tvChannelItems : [],
            status: AppStatus.Success
        })
    }

    public setOptionalChannels(channels: api.IChannel[]) {
        const optionalChannels = channels.find(tvChannel => tvChannel.name === "Valgfrie kanaler");

        this.setState({
            channelType: ChannelType.Optional,
            optional: optionalChannels ? optionalChannels.tvChannelItems : [],
            status: AppStatus.Success
        })
    }

    public setChannelPacks(channels: api.IChannel[]) {
        const channelPacks = channels.filter(tvChannel => tvChannel.name !== "Valgfrie kanaler" && tvChannel.name !== "Faste kanaler");

        this.setState({
            channelType: ChannelType.ChannelPacks,
            channelPacks: channelPacks as IChannelPackage[],
            status: AppStatus.Success
        })
    }

    public renderChannels() {
        switch (this.state.channelType) {
            case ChannelType.Fixed:
                return this.state.fixed!.map((channel) => {
                    return (
                        <Channel
                            name={channel.name}
                            src={Util.getImageUrl(channel.tvChannelIcons)}
                            key={channel.id}
                            shortDescription={channel.shortDescription}
                            longDescription={channel.longDescription}
                        />
                    );
                });
            case ChannelType.Optional:
                return this.state.optional!.map((channel) => {
                    return (
                        <Channel
                            name={channel.name}
                            key={channel.id}
                            src={Util.getImageUrl(channel.tvChannelIcons)}
                            longDescription={channel.longDescription}
                            shortDescription={channel.shortDescription}
                            points={channel.points}
                        />
                    );
                });
            case ChannelType.ChannelPacks:
                return this.state.channelPacks!.map((channelPackage) => {
                    return (
                        <ChannelPackage
                            name={channelPackage.name}
                            description={channelPackage.description}
                            points={channelPackage.points}
                            src={Util.getPackageImageUrl(channelPackage.icons)}
                            key={channelPackage.name}
                        />
                    );
                });
        }
        return;
    }

    public renderByStatus() {
        switch(this.state.status) {
            case AppStatus.Loading:
                return <Loader />;

            case AppStatus.Error:
                return (
                    <div className="text-danger">
                        Beklager, vi har problemer med å hente kanaloversikten. Vennligst prøv igjen senere.
                    </div>
                );

            case AppStatus.Success:
                return this.renderChannels();
        }
        return;
    }

    public componentWillMount() {
        const channelType = this.props.parameter;

        api.fetchChannels(this.state.countryCode)
            .then(channels => {
                switch(channelType) {
                    case ChannelType.Fixed:
                        return this.setFixedChannels(channels);

                    case ChannelType.Optional:
                        return this.setOptionalChannels(channels);

                    case ChannelType.ChannelPacks:
                        return this.setChannelPacks(channels);
                }
            })
            .catch(() => this.setState({status: AppStatus.Error}));
    }

    public render() {
        return (
            <div className="foc" id="foc">
                <div className="product-box">
                    {this.renderByStatus()}
                </div>
                <div id="modalBg" />
            </div>
        );
    }
}

export default App;